module.exports = __webpack_public_path__ + "img/girlForCheck1.2187234a.jpg";